import React, { useState } from 'react';
import './EditableSection.css';

interface EditableSectionProps {
  title: string;
  paragraph: string;
  onSave: (newTitle: string, newParagraph: string) => void;
}

const EditableSection: React.FC<EditableSectionProps> = ({ title, paragraph, onSave }) => {
  const [isAccordionOpen, setIsAccordionOpen] = useState(false);
  const [newTitle, setNewTitle] = useState(title);
  const [newParagraph, setNewParagraph] = useState(paragraph);

  const toggleAccordion = () => {
    setIsAccordionOpen(!isAccordionOpen);
  };

  const handleSave = () => {
    onSave(newTitle, newParagraph);
  };

  return (
    <div className="editor-accordion">
      <div className="accordion-item">
        <h3 onClick={toggleAccordion}>Editar Sección ¿Qué hacemos?</h3>
        {isAccordionOpen && (
          <div className="accordion-content">
            <label htmlFor="section-title">Título:</label>
            <input
              type="text"
              id="section-title"
              value={newTitle}
              onChange={(e) => setNewTitle(e.target.value)}
            />

            <label htmlFor="section-paragraph">Párrafo:</label>
            <textarea
              id="section-paragraph"
              value={newParagraph}
              onChange={(e) => setNewParagraph(e.target.value)}
            />

            <button onClick={handleSave}>Guardar Cambios</button>
          </div>
        )}
      </div>
    </div>
  );
};

export default EditableSection;
